import { useNavigate, useParams } from "react-router-dom";
import ProfileNav from "./ProfileNav";
import ProfileEdit from "./ProfileEdit";
import ProfileHeader from "./ProfileHeader";
import ProfilePasswordChange from "./ProfilePasswordChange";
import ProfileSettings from "./ProfileSettings";
import ProfileSubscriptionPlan from "./ProfileSubscriptionPlan";
import ProfileHelpSupport from "./ProfileHelpSupport";
import { ProfileSectionType } from "../../../types";
import { useAuth } from "../../../context/AuthContext";
import ProfileDeletionRequest from "./ProfileDeletionRequest";

const UserProfile = () => {
  const { section } = useParams<{ section?: ProfileSectionType }>();
  const { logout } = useAuth();
  const navigate = useNavigate();

  const showHeader = section !== "subscription";
  // const showHeader = true;

  const handleTopNavBtn = () => {
    if (!section || section === "profile") {
      navigate("/dashboard");
    } else {
      navigate("/profile");
    }
  };

  const RenderBody = {
    profile: <ProfileNav handleLogout={logout} />,
    edit: <ProfileEdit />,
    settings: <ProfileSettings />,
    "password-change": <ProfilePasswordChange />,
    subscription: <ProfileSubscriptionPlan />,
    help: <ProfileHelpSupport />,
    "request-delete": <ProfileDeletionRequest />,
  };

  return (
    <div className="w-full h-full">
      <div className="w-full h-full flex flex-col items-center mx-auto max-w-[calc(100%-64px)] xl:max-w-[1024px] pt-6 pb-6">
        {showHeader && (
          <ProfileHeader section={section} handleTopNavBtn={handleTopNavBtn} />
        )}

        <div className="w-full h-full overflow-y-auto">
          {RenderBody[section || "profile"]}
        </div>
      </div>
    </div>
  );
};

export default UserProfile;
